import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const purpleDotSettings = defineIntegrationSettings({
  fields: {
    enabled: z.boolean(),
    publicKey: z.string().trim().min(1, "Public key is required"),
  },
  secrets: { privateKey: z.string().trim().min(1, "Private key is required") },
  connectOnly: {},
  computed: {},
});
